/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "ReviewPortfolioPageService";
const log: any = LoggerModule.getInstance();

export class ReviewPortfolioPageService {
    private static instance: ReviewPortfolioPageService;
    private vapp: VApplication;
    private formData: any = [];
    private credentialForm: any = [];
    private evidenceKanbanList: any = [];
    private createPortfolio: any = {};
    private portfolioTempId:string = "";
    private constructor(props: any = {}) {
      this.vapp = VApplication.getInstance();
    }
  
    public static getInstance(
      props: any = {}
    ): ReviewPortfolioPageService {
      if (!ReviewPortfolioPageService.instance) {
        ReviewPortfolioPageService.instance =
          new ReviewPortfolioPageService(props);
      }
      return ReviewPortfolioPageService.instance;
    }
  
    public async getPageContent(args:any) {
      let content: any = {};
      let compProps: any = null;
      const agent = getAgent();
      
      //Template Form
      compProps = await agent.getPortfolioFormProps(args);
      console.log('credential portfolio temp id', compProps);
      if (compProps) {
        this.credentialForm = compProps;
        this.portfolioTempId = compProps?.portfolio?.portfolioTempId
        content = { ...content, ...compProps };
      }
  
    //   //Evidence Kanban Props
    //   compProps = await agent.getEvidenceKanbanProps({});
    //   if (compProps) {
    //     content = { ...content, ...compProps };
    //     this.evidenceKanbanList = compProps.evidenceKanbanList;
    //   }
  
    //   //CreateTemplate Props
    //   compProps = await agent.getCreateTemplateProps({});
    //   if (compProps) {
    //     content = { ...content, ...compProps, ...this.createPortfolio };
    //   }
  
      return content;
    }
  
    public getStaticPageContent() {
      let content: any = {};
      let compProps: any = null;
      const agent = getAgent();
  
      compProps = agent.getStaticPageContentSync({});
      if (compProps) {
        content = { ...content, ...compProps };
      }
      return content;
    }
  
    public updateStatus(args:any){
      console.log(`status in service`, args)
      const agent = getAgent();
      return agent.getUpdatePortfolioStatus(args);
    }

    public showcasePortfolio(args:any){
      const agent = getAgent();
      return agent.getShowcasePortfolio(args);
    }

    public unlistPortfolio(args:any){
      const agent = getAgent();
      return agent.getUnlistPortfolio(args);
    }

    // public async initiateDraft(){
    //   const agent = getAgent();
    //   const _args = {
    //     submit:false
    //   };
    //   return await agent.getSubmitPortfolio(_args);
    // }

  }